// Re-position the "popped" menu when the window is resized.
window.addEventListener('resize', e => {
  document.querySelectorAll('aha-menu-content[open]').forEach(menuContent => {
    const menu = menuContent.closest('aha-menu');
    if (menu) menu.positionPopper();
  });
});
